import { workflowsRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';
import { AssociateTaskToWorkflow } from '../types';

export const useAssociateTaskToWorkflow = () =>
  useMutation<ApiResponse<unknown>, unknown, AssociateTaskToWorkflow>(
    (taskWorkflow) => workflowsRepo.associateTaskToWorkflow(taskWorkflow),
  );
